import { render, staticRenderFns } from "./partner-wallet.vue?vue&type=template&id=018f23da&scoped=true&"
import script from "./partner-wallet.vue?vue&type=script&lang=js&"
export * from "./partner-wallet.vue?vue&type=script&lang=js&"
import style0 from "./partner-wallet.vue?vue&type=style&index=0&id=018f23da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f23da",
  null
  
)

export default component.exports